import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  isOpen: false,
};

const modalSlice = createSlice({
    name: "customersModal",
    initialState: initialState,
    reducers: {
        openCustomersModal: (state) => {
            state.isOpen = true;
        },

        closeCustomersModal: (state) => {
            state.isOpen = false;
        }
    }
})

export const { openCustomersModal, closeCustomersModal } = modalSlice.actions;
export default modalSlice.reducer